import Vue from 'vue'
import hash from '~/utils/hash'
import { platformMutations } from '~/helpers/store'

export default {
  ...platformMutations,

  searchFetching: (s, params) => {
    const hashedSearch = hash(params)
    if (hashedSearch && !s.meta.searches[hashedSearch]) {
      const search = {
        fetching: true,
        failed: false,
        errorMessages: [],
        pages: [],
        totalPages: null
      }
      Vue.set(s.meta.searches, hashedSearch, search)
    }
    const search = Object.assign({}, s.meta.searches[hashedSearch])
    search.fetching = true
    Vue.set(s.meta.searches, hashedSearch, search)
  },

  searchFetched: (s, params) => {
    const hashedSearch = hash(params)
    if (s.meta.searches[hashedSearch]) {
      const search = Object.assign({}, s.meta.searches[hashedSearch])
      search.fetching = false
      Vue.set(s.meta.searches, hashedSearch, search)
    }
  },

  searchFailed: (s, { params, failed }) => {
    const hashedSearch = hash(params)
    if (s.meta.searches[hashedSearch]) {
      const search = Object.assign({}, s.meta.searches[hashedSearch])
      search.failed = failed
      Vue.set(s.meta.searches, hashedSearch, search)
    }
  },

  saveSearch: (s, { params, notes, meta }) => {
    const { page, totalPages } = meta
    delete params.page
    const hashedSearch = hash(params)
    let search = {
      pages: [],
      totalPages: null
    }
    if (s.meta.searches[hashedSearch]) {
      search = Object.assign({}, s.meta.searches[hashedSearch])
    }
    search.pages[page - 1] = notes.map(note => note.id)
    search.totalPages = totalPages

    Vue.set(s.meta.searches, hashedSearch, search)
  },

  setNoteFilter: (s, { filter, value }) => {
    Vue.set(s.filters, filter, value)
  },

  rehydrateNoteFilters: (s, { filters }) => {
    const mergedFilters = {
      ...s.filters,
      ...filters
    }

    Vue.set(s, 'filters', mergedFilters)
  },

  resetNoteFilters: (s, defaultFilters) => {
    Vue.set(s, 'filters', defaultFilters)
  },

  unsetNoteFilter: (s, { filter, value }) => {
    const noteViewFilters = Object.assign({}, s.filters[filter])
    noteViewFilters[filter] = value
    Vue.set(s, 'filters', noteViewFilters)
  },

  clearSubscribedNotes: (s, { params }) => {
    const hashedSearch = hash(params)

    if (hashedSearch) {
      const searches = Object.assign({}, s.meta.searches)
      delete searches[hashedSearch]
      Vue.set(s.meta, 'searches', searches)
    }
  }
}
